import React, {FC, PropsWithChildren} from 'react';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface BannerContentProps {
  className?: string;
}

/*
 * Style.
 */

const StyledContentDiv = styled.div<BannerContentProps>`
  position: relative;
  grid-area: content;
  min-width: 0;
  line-height: 17px;
  margin-bottom: 12px;

  color: ${(p) => p.theme.bannerText};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const BannerContent: FC<PropsWithChildren<BannerContentProps>> = ({children, className}) => (
  <StyledContentDiv className={className}>{children}</StyledContentDiv>
);
